import { createBrowserRouter } from "react-router-dom";
import home from "./home.routes";

const router = createBrowserRouter([...home]);

export default router;
